module.exports = __webpack_public_path__ + "img/oops.143b30e4.png";